class ResponsiveTablesLight {
  constructor(config = {}) {
    const {
      tableComponentSelector,
      tableContainerSelector,
      tableSelector
    } = config;

    this.tables = document.querySelectorAll(tableSelector);
    this.tablesArray = Array.from(this.tables);

    if (this.tables) {
      this.tablesArray.forEach(table => {
        let container = table.closest(tableContainerSelector);
        let component = table.closest(tableComponentSelector);

        this.toggleResponsiveTableClasses(component, container, table);

        if (component.classList.contains('responsive-table-alternative')) {
          this.enableDragScroll(container);
        }
      });
    }
  }

  toggleResponsiveTableClasses(component, container, table) {
    const updateClasses = () => {
      const hasScroll = this.hasHorizontalScrollbar(container, table);
      const hasRowspan = this.hasRowSpan(table);

      if (hasScroll && !hasRowspan) {
        component.classList.add('has-shadow', 'responsive-table');
        component.classList.remove('responsive-table-alternative');
      } else if (hasScroll && hasRowspan) {
        component.classList.add('responsive-table-alternative');
        component.classList.remove('has-shadow', 'responsive-table');
      } else {
        component.classList.remove('has-shadow', 'responsive-table', 'responsive-table-alternative');
      }
    };

    updateClasses();

    window.addEventListener('resize', updateClasses);
  }

  hasHorizontalScrollbar(container, table) {
    const containerWidth = container.clientWidth;
    const tableWidth = table.clientWidth;
    return tableWidth > containerWidth;
  }

  hasRowSpan(table) {
    const tableCells = table.querySelectorAll('td[rowspan]');
    return tableCells.length > 0;
  }

  enableDragScroll(container) {
    let isDragging = false;
    let startX;
    let scrollLeft;

    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      container.classList.add('dragging');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Adjust speed
      container.scrollLeft = scrollLeft - walk;
    });

    container.addEventListener('mouseup', () => {
      isDragging = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mouseleave', () => {
      isDragging = false;
      container.classList.remove('dragging');
    });
  }
}

export default ResponsiveTablesLight;
